import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouteContext } from '@tanstack/react-router';

import { Dashboard } from '~/components/Dashboard/Dashboard';
import { Landing } from '~/components/Landing/Landing';
import type { TAppRouter } from '~/router';
import { gameQueries } from '~/stores/gameStore';
import { useIsLoggedIn } from '~/stores/onboardStore';

export const Route = createFileRoute('/')({
  loader: async ({ context }) => {
    // On the server, data is fetched and embedded in the HTML
    await context.queryClient.ensureQueryData(
      gameQueries.list({}, context.queryClient),
    );
  },
  component: HomePage,
});

function HomePage() {
  const { queryClient, user } = useRouteContext<TAppRouter, '/'>({
    from: '/',
  });
  const isLoggedIn = useIsLoggedIn();
  const isServer = typeof window === 'undefined';
  const isAuthenticated = isServer ? Boolean(user) : Boolean(isLoggedIn);
  const { data, isLoading } = useSuspenseQuery(
    gameQueries.list({}, queryClient),
  );

  return isAuthenticated ? (
    <Dashboard gamesData={data} isLoading={isLoading} />
  ) : (
    <Landing gamesData={data} isLoading={isLoading} />
  );
}
